import { useScrollCallback } from './useScrollCallback';

export function useScrollToError(
    errorClassName = 'ovpn-form-field-description ovpn-form-field-error-description',
) {
    const scrollToError = useScrollCallback({
        className: errorClassName,
        shouldGetParentElement: true,
        options: { block: 'center' },
        timeout: 100,
    });

    return scrollToError;
}
